import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { globalBodyPrimary, globalCtaLarge } from '@internal/ui/typography';
import { Base } from '@internal/ui/palette/base';

interface JobDetail {
    className?: string;
    label: string;
    values: string[];
}

const JobDetail: React.FC<JobDetail> = ({ label, values }) => (
    <DetailStyled>
        <DetailLabelStyled>{label}</DetailLabelStyled>
        {values.map((value) => (
            <DetailValueStyled key={value}>{value}</DetailValueStyled>
        ))}
    </DetailStyled>
);

const DetailValueStyled = styled.div`
    ${globalCtaLarge}
    color: ${Base.Primary100};
`;

const DetailLabelStyled = styled.div`
    ${globalBodyPrimary}
    color: ${Base.Primary200};
    margin-bottom: ${rem(4)};
`;

const DetailStyled = styled.div`
    margin-bottom: ${rem(16)};

    &:not(:last-child) {
        margin-right: ${rem(40)};
    }
`;

export default JobDetail;
